<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div class="form-group">
				<label>Modify template:</label>
				<select [(ngModel)]="selectedTemplate" (ngModelChange)="templateChange($event)" class="form-control">
					<option *ngFor="let template of templates" [ngValue]="template">{{template.description}}</option>
				</select>
			</div>
		</div>
	</div>
	<div *ngIf="selectedTemplate" class="row">
		<div *ngIf="selectedTemplate.template_id !== null" class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Current template</div>
				<div class="content">
					<div>
						<textarea [(ngModel)]="rawTemplate" style="width: 100%;height: 400px;" readonly></textarea>
					</div>
				</div>
			</div>
			<app-action-button [action]="DeleteTemplate" [context]="this" processing="Deleting..." complete="Template deleted"
			 confirm="Are you sure?" btnClass="btn-danger">Delete Template</app-action-button>
		</div>
		<div *ngIf="selectedTemplate.template_id === null" class="col-lg-6">
			<div class="item-panel">
				<div class="heading">New template name</div>
				<div class="content">
					<div>
						<input [(ngModel)]="newTemplateDescription" type="text" class="form-control">
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">New template</div>
				<div class="content">
					<div>
						<textarea [(ngModel)]="newTemplate" style="width: 100%;height: 400px;"></textarea>
					</div>
				</div>
			</div>
			<app-action-button *ngIf="selectedTemplate.template_id !== null" [action]="UploadTemplate" [context]="this"
			 processing="Updating..." complete="Template updated" btnClass="btn-success">Update Template</app-action-button>
			<app-action-button *ngIf="selectedTemplate.template_id === null" [action]="CreateTemplate" [context]="this"
			 processing="Creating..." complete="Template created" btnClass="btn-success">Create Template</app-action-button>
		</div>
	</div>
</div>